import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';

import RightArrow from '../../../assets/svg/cursor-right-arrow.svg';
import { toCamelCase } from '../../../utils';

const Story = ({ data, type = 'standard' }) => {
  const { color, franchise, image, slug, storyHeader, subHeader } = data;
  const getColor = toCamelCase(color);

  const imageBase = (
    <GatsbyImage
      alt={storyHeader}
      image={getImage(image)}
      style={{ height: '100%' }}
    />
  );

  const imageContainer = <div className="image">{imageBase}</div>;
  const imageTallContainer = <div className="image-tall">{imageBase}</div>;
  const imageLongContainer = <div className="image-long">{imageBase}</div>;
  const largeBoxContent = (
    <div className="large-box__content">
      <div className="large-box__content--header">{storyHeader}</div>
      <div className="large-box__content--link-wrapper">
        <RightArrow />
      </div>
      <div className={`large-box__content--sub-header ${getColor}`}>
        {subHeader}
      </div>
    </div>
  );
  const largeBox = <div className="large-box">{largeBoxContent}</div>;
  const tallBox = <div className="tall-box">{largeBoxContent}</div>;
  const featuredBox = <div className="featured-box">{largeBoxContent}</div>;
  const smallBox = (
    <div className="small-box">
      <div className="small-box__content">
        <div className="small-box__content--header">
          {franchise.franchiseName}
        </div>
        <div className="small-box__content--subHeader">{storyHeader}</div>
      </div>
    </div>
  );

  const typeMap = {
    featured: (
      <div className="story-content-card__featured">
        {imageContainer}
        {featuredBox}
      </div>
    ),
    long: (
      <div className="story-content-card__long">
        {imageLongContainer}
        {largeBox}
      </div>
    ),
    standard: (
      <div className="story-content-card__standard">
        {imageContainer}
        {smallBox}
      </div>
    ),
    tall: (
      <div className="story-content-card__tall">
        {imageTallContainer}
        {tallBox}
      </div>
    ),
  };

  return (
    <Link to={`/story/${slug}/`}>
      <div className="story-content-card">{typeMap[type]}</div>
    </Link>
  );
};

Story.propTypes = {
  data: PropTypes.object,
  type: PropTypes.string,
};

export default Story;
